import { useEffect, useState } from "react";
import { useShopifyScript } from "../hooks/useShopifyScript";

const SAMPLE_BUTTON_ID = "adhawk-shopify-camilyo-marketplace-order-sample";

export default function SampleOrderButton({
  productInfo = {},
  universalRetailerId,
  samplePrice,
  visible = true,
  isLoading = false,
  onClick = () => {},
  label = "Order Sample",
  buttonClassName = "",
  labelClassName = "",
}) {
  const [isScriptReady, setIsScriptReady] = useState(false);
  const { loadScript, isLoaded } = useShopifyScript({ autoRegister: true });

  useEffect(() => {
    if (!isLoaded) {
      loadScript();
    }
  }, [isLoaded, loadScript]);

  useEffect(() => {
    if (isLoaded) {
      setIsScriptReady(true);
    }
  }, [isLoaded]);

  useEffect(() => {
    const intervalId = setInterval(() => {
      if (window?.ShopifyBuy !== undefined) {
        setIsScriptReady(true);
        clearInterval(intervalId);
      }
    }, 1000);

    if (window?.ShopifyBuy !== undefined) {
      setIsScriptReady(true);
      clearInterval(intervalId);
    }

    return () => {
      clearInterval(intervalId);
    };
  }, []);

  if (!visible) {
    return null;
  }

  const productHandle =
    productInfo?.UPID || productInfo?.upid || productInfo?.handle || "";
  const disabled =
    isLoading || !isScriptReady || !productHandle || !universalRetailerId;

  return (
    <button
      id={SAMPLE_BUTTON_ID}
      type="button"
      data-product-handle={productHandle}
      data-universal-retailer-id={universalRetailerId}
      disabled={disabled}
      onClick={onClick}
      className={`${buttonClassName} ${disabled ? "disabled" : ""}`.trim()}>
      <span className={labelClassName}>
        {samplePrice ? `($${samplePrice}) ${label}` : label}
      </span>
    </button>
  );
}
